import { useEffect, useRef } from 'react'
import { EditorView } from 'prosemirror-view'
import { fetchStream } from 'common/Prose/nodeViews/AISuggestion/utils'
import { Node } from 'prosemirror-model'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  jobId: string
  view: EditorView
  streamContent: string
  setStreamContent: React.Dispatch<React.SetStateAction<string>>
  className?: string
}

export const StreamContentData = ({ jobId, view, className, streamContent, setStreamContent }: Props) => {
  const bottomRef = useRef<HTMLDivElement | null>(null)
  const { isMobile } = useResponsiveDesign()

  useEffect(() => {
    fetchStream({
      jobId,
      onParsedLine: (line: string) => {
        setStreamContent((content) => content + line)
        if (!isMobile) bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      },
    })
  }, [isMobile, jobId, setStreamContent])

  if (!streamContent) return null

  const wrappedNode = Node.fromJSON(view.state.schema, { type: 'doc', content: JSON.parse(streamContent) })
  const content = wrappedNode.content.content.map((c) => c.textContent.toString()).join('\r\n\n')

  return (
    <>
      <div className={className}>{content}</div>
      <div ref={bottomRef} />
    </>
  )
}
